import {Pill} from '@hm/fundamental'

import {priorityColor} from '../../helpers'
import {useRiskSurveyTranslation} from '../../hooks'
import type {RiaPriority} from '../../types'

type RiaPriorityPillProps = {
  priority: RiaPriority
}

export const RiaPriorityPill = ({priority}: RiaPriorityPillProps) => {
  const {t} = useRiskSurveyTranslation()
  const translatedPriority = t(`priority.${priority}`)

  return (
    <Pill
      type={priorityColor[priority]}
      text={translatedPriority}
      aria-label={`${t('detail.priority')}: ${translatedPriority}`}
      variant="shade"
      size="regular"
      data-cy={`ria-priority-pill-${priority}`}
    />
  )
}
